// extracted by mini-css-extract-plugin
export default {"menuItem":"ActionColumn_menuItem__VgKqp"};